
import {
    Directive,
    Renderer2,
    HostListener,
    ElementRef,
    HostBinding,
    ContentChild,
    Input
} from '@angular/core';
import { Observable } from 'rxjs/Observable';

interface PageSize {
    pageX: number;
    pageY: number;
}
/**
 * 常规Hostlistener监听事件
 */
export class DragBoxDirective {
     box: any;
private pageSize: PageSize;
    dragging: boolean;
/**
 * @param {?} rd2
 * @param {?} el
 */
constructor(private rd2: Renderer2,
private el: ElementRef) { }
/**
 * @return {?}
 */
ngOnInit() {
        const { x, y } = this.center(this.box);
        this.center(this.box);
    }
/**
 * @return {?}
 */
ngOnDestroy() {
        this.dragging = false;
    }
/**
 * @param {?} event
 * @param {?} target
 * @return {?}
 */
mousedown(event: MouseEvent, target) {
        if (target.className.indexOf('ant-modal-close-x') !== -1) return;
        event.stopPropagation();
        this.dragging = true;
        this.pageSize = event;
    }
/**
 * @param {?} __0
 * @return {?}
 */
mousemove({ pageX, pageY }) {
        const /** @type {?} */ dom = this.box;
        if (this.dragging) {
            let /** @type {?} */ deltaX = pageX - this.pageSize.pageX, /** @type {?} */
                deltaY = pageY - this.pageSize.pageY, /** @type {?} */
                distanceX = document.documentElement.offsetWidth - dom.offsetWidth, /** @type {?} */
                distanceY = document.documentElement.offsetHeight - dom.offsetHeight, /** @type {?} */
                leftPos = parseInt(dom.offsetLeft), /** @type {?} */
                topPos = parseInt(dom.offsetTop);

            dom.style.left = (leftPos >= 0 ? (leftPos <= distanceX ? leftPos + deltaX : distanceX) : 0) + 'px';
            dom.style.top = (topPos >= 0 ? (topPos <= distanceY ? topPos + deltaY : distanceY) : 0) + 'px';

            this.pageSize = { pageX, pageY };
        }
        return false;
    }
/**
 * @param {?} event
 * @return {?}
 */
mouseup(event: MouseEvent) {
        this.dragging = false;
    }
/**
 * @param {?} event
 * @return {?}
 */
resize(event: MouseEvent) {
        this.center(this.box);
    }
/**
 * @return {?}
 */
getViewport(): any {
        let /** @type {?} */ win = window, /** @type {?} */
            d = document, /** @type {?} */
            e = d.documentElement, /** @type {?} */
            g = d.getElementsByTagName('body')[0], /** @type {?} */
            w = win.innerWidth || e.clientWidth || g.clientWidth, /** @type {?} */
            h = win.innerHeight || e.clientHeight || g.clientHeight;

        return { width: w, height: h };
    }
/**
 * @param {?} ele
 * @return {?}
 */
center(ele: any) {
        const /** @type {?} */ viewport = this.getViewport(), /** @type {?} */
            x = Math.max((viewport.width - ele.offsetWidth) / 2, 0), /** @type {?} */
            y = Math.max((viewport.height - ele.offsetHeight) / 2, 0);

        this.box.style.position = `fixed`;
        this.box.style.zIndex = 1000;
        this.box.style.left = x + 'px';
        this.box.style.top = y + 'px';

        return { x, y }
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
    selector: '[drag-box]'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer2, },
{type: ElementRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'box': [{ type: Input },],
'mousedown': [{ type: HostListener, args: ['mousedown', ['$event', '$event.target'], ] },],
'mousemove': [{ type: HostListener, args: ['document:mousemove', ['$event'], ] },],
'mouseup': [{ type: HostListener, args: ['document:mouseup', ['$event'], ] },],
'resize': [{ type: HostListener, args: ['window:resize', ['$event'], ] },],
};
}

function DragBoxDirective_tsickle_Closure_declarations() {
/** @type {?} */
DragBoxDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DragBoxDirective.ctorParameters;
/** @type {?} */
DragBoxDirective.propDecorators;
/** @type {?} */
DragBoxDirective.prototype.box;
/** @type {?} */
DragBoxDirective.prototype.pageSize;
/** @type {?} */
DragBoxDirective.prototype.dragging;
/** @type {?} */
DragBoxDirective.prototype.rd2;
/** @type {?} */
DragBoxDirective.prototype.el;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
